export default "__VITE_ASSET__CUgEPMTC__"